import axios from "axios";
import apis from "./apis";

import { Service } from "axios-middleware";
import removeLocalItem from "./removeLocalStorage";
import store from "../store";
import { logout } from "../actions/authAction";
import moment from "moment";
import logService from "./logService";

const service = new Service(axios);

service.register({
  onRequest(config) {
    const portal = config.baseURL;
    const page = window.location.pathname?.replace(/\d+/g, "ID_REMOVED");
    const end_point_name = config.url?.replace(/\d+/g, "ID_REMOVED");

    const postData = {
      date: moment().format("YYYY-MM-DD"),
      portal: portal,
      page: page,
      // calls_count: 1,
      end_point_name: end_point_name,
      external_or_rfc: "", // external or rfc
    };

    if (
      end_point_name.includes("rfc-reducer") ||
      end_point_name.includes("/login/") ||
      end_point_name.includes("incoterms") ||
      end_point_name.includes("from_table") ||
      end_point_name.includes("table_name") ||
      end_point_name.includes("/image/") ||
      end_point_name.includes("rake-data")
    ) {
      postData.external_or_rfc = "external";
    } else {
      postData.external_or_rfc = "rfc";
    }

    if (
      postData.end_point_name.includes("/update_so_requests_with_login_id") ||
      postData.end_point_name.includes("/image/") ||
      postData.end_point_name.includes("/login/")
    ) {
      console.log("Bypassing logService");
    } else {
      // logService(postData);
    }

    return config;
  },
  onResponse(response) {
    let data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (
      (data.code === 100 && data.status === false && data.message === "Auth failed") ||
      (data.message && typeof data.message === 'string' && data.message.toLowerCase().includes("revoked")) ||
      data.message === "Session expired"
    ) {
      console.log("Auth failed or revoked");
      localStorage.removeItem("Token");
      localStorage.removeItem("user_code");
      removeLocalItem();
      store.dispatch(logout());
    }
    return response;
  },
  onResponseError(error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log("Auth failed with 401/403");
      localStorage.removeItem("Token");
      localStorage.removeItem("user_code");
      removeLocalItem();
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
});

const http = axios.create({
  baseURL: apis.BASE,
});

// Global Interceptor for Button Loading State
let activeRequests = 0;
let lastClickedButton = null;
let lastClickedOriginalText = null;
let revertButtonTimeout = null;

http.interceptors.request.use((config) => {
  activeRequests++;
  if (lastClickedButton && activeRequests === 1) {
      lastClickedButton.disabled = true;
      lastClickedOriginalText = lastClickedButton.innerHTML;
      lastClickedButton.innerHTML = 'Processing...';
      document.body.style.pointerEvents = 'none';
  }
  return config;
}, (error) => Promise.reject(error));

const restoreButton = () => {
  if (lastClickedButton) {
      lastClickedButton.disabled = false;
      if (lastClickedOriginalText !== null) {
          lastClickedButton.innerHTML = lastClickedOriginalText;
      }
      lastClickedButton = null;
      lastClickedOriginalText = null;
  }
  document.body.style.pointerEvents = 'auto';
};

http.interceptors.response.use((response) => {
  activeRequests--;
  if (activeRequests <= 0) {
      activeRequests = 0;
      restoreButton();
  }
  return response;
}, (error) => {
  activeRequests--;
  if (activeRequests <= 0) {
      activeRequests = 0;
      restoreButton();
  }
  return Promise.reject(error);
});

// Global click listener to track the last clicked button
if (typeof document !== 'undefined') {
  document.addEventListener('click', (e) => {
      const btn = e.target.closest('button') || e.target.closest('input[type="submit"]') || e.target.closest('input[type="button"]');
      if (btn && !btn.disabled) {
          lastClickedButton = btn;
          if (revertButtonTimeout) clearTimeout(revertButtonTimeout);
          // If no API request starts within 100ms, forget the button
          revertButtonTimeout = setTimeout(() => {
              if (activeRequests === 0) {
                  lastClickedButton = null;
                  lastClickedOriginalText = null;
              }
          }, 100);
      }
  }, true);
}

export default http;
